import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {Translate} from "../../../../config/Translate";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import axios from "axios";
import {defaultVariabls} from "../../../../config";
import {connect} from "trim-redux";
import TextField from "@material-ui/core/TextField/TextField";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import {DialogActions, ListItem, TableContainer, withStyles} from "@material-ui/core";
import {Styles} from "../../../../config/design/styles";
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import IconButton from "@material-ui/core/IconButton/IconButton";
import Grid from "@material-ui/core/Grid/Grid";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import LoadingButton from "../../../components/elements/LoadingButton";
import ChatRoundedIcon from '@material-ui/icons/ChatRounded';
import Menu from "@material-ui/core/Menu/Menu";
import ButtonGroup from "@material-ui/core/ButtonGroup/ButtonGroup";
import GetAppTwoToneIcon from '@material-ui/icons/GetAppTwoTone';
import Typography from "@material-ui/core/Typography/Typography";
import SubTitleLight from "../../../components/elements/SubTitleLight";
import SingleFileChooser from "../../fileManager/Components/SingleFileChooser";
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import List from "@material-ui/core/List/List";
import ListItemIcon from "@material-ui/core/ListItemIcon/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import Divider from "@material-ui/core/Divider/Divider";
import CloudDownloadRoundedIcon from '@material-ui/icons/CloudDownloadRounded';
import Alert from "@material-ui/lab/Alert/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle/AlertTitle";
import {updateRedux} from "../../../../config/Security";
import ContactSupportRoundedIcon from '@material-ui/icons/ContactSupportRounded';
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import LoadingButtonWithConfirmation from "../../../components/elements/LoadingButtonWithConfirmation";
import CheckBoxRoundedIcon from '@material-ui/icons/CheckBoxRounded';
import BackupRoundedIcon from '@material-ui/icons/BackupRounded';
class ExcelImportButton extends React.Component{
    state = {
        SubmitLoading:false,
        loading:false,
        open:false,
        dry_run:true,
        file:'',
        errors:[],
    };
    toggleOpen(){
        this.setState({
            open: !this.state.open,
        })
    }
    handleValidation(callback){
        let { file } = this.state;
        let errors = {};
        let formIsValid = true;
        if(!file){
            let formIsValid = false;
        }
        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                SubmitLoading:false,
                errors
            })
        }
        return callback(formIsValid)
    }
    handleRequest(){
        const {file,dry_run} = this.state;
        let data = new FormData();
        data.append('id', file.id);
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/products/import_from_excel/${!!dry_run ? "dry" : "action"}`, data, config)
            .then(response => {
                if(!dry_run){
                    this.setState({
                        SubmitLoading:false,
                        open:false,
                    });
                    this.props.enqueueSnackbar(Translate.allProductsImported, {
                        variant: 'success',
                    });
                    updateRedux();
                    this.props.reload()
                }else{
                    this.setState({
                        SubmitLoading:false,
                        dry_run:false,
                    });
                }

            })
            .catch(error => {
                console.log(error.response)
                if(error.response.status === 403){
                    this.props.enqueueSnackbar(Translate.youReachedYourLimit, {
                        variant: 'error',
                    });
                }else{
                    this.props.enqueueSnackbar(Translate.importHasProblem, {
                        variant: 'error',
                    });
                }

                this.setState({
                    errors:error.response.data,
                    SubmitLoading:false
                });
            });
    }
    handleSubmit(e){
        this.setState({
            SubmitLoading:true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }

        });
    }
    handleFile(file){
        this.setState({
            file,
            dry_run:true,
            errors:[]
        })
    }
    render(){
        let {SubmitLoading,open,file,errors,dry_run} = this.state;
        return (
            <>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<GetAppTwoToneIcon/>}
                    onClick={() => this.toggleOpen()}
                >
                    {Translate.importFromExcel}
                </Button>
                <Button
                    component={"a"}
                    href={"https://epanjere.com/uploads/FileManager/v4.mp4"}
                    target="_blank"
                    color="secondary"
                    style={{marginRight:10,marginLeft:10}}
                    startIcon={<ContactSupportRoundedIcon/>}
                >
                    {Translate.viewTutorial}
                </Button>
                <Dialog
                    open={open}
                    onClose={() => this.toggleOpen()}
                    aria-labelledby="form-dialog-title"
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle id="form-dialog-title">
                        <IconButton
                            onClick={() => this.toggleOpen()}
                            style={{position:"absolute",left:15,top:15}}
                            size="small"
                        >
                            <CloseRoundedIcon fontSize="small"/>
                        </IconButton>
                        {Translate.importFromExcel}
                    </DialogTitle>
                    <DialogContent style={{minHeight:140}}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography paragraph>{Translate.pleaseDownloadTemplateFirst}</Typography>
                            </Grid>
                            <Grid item xs={12} md={6}  style={{textAlign:"center",marginBottom:15}}>
                                <Button
                                    size="small"
                                    color={"secondary"}
                                    component={"a"}
                                    variant="outlined"
                                    href={`${defaultVariabls.website}/template.xlsx`}
                                    startIcon={<CloudDownloadRoundedIcon/>}
                                    style={{color:"green",borderColor:"green"}}
                                >
                                    {Translate.downloadExcel}
                                </Button>
                            </Grid>
                            <Grid item xs={12} md={6}  style={{textAlign:"center",marginBottom:15}}>
                                <SingleFileChooser
                                    importer
                                    icon={<BackupRoundedIcon/>}
                                    label={Translate.ExcelImportBtnLabel}
                                    onChange={(file) => this.handleFile(file)}
                                    color="secondary"
                                />
                            </Grid>
                            {/*<Grid item xs={12}>
                                <SubTitleLight align="left">{Translate.importHint}</SubTitleLight>
                                <List dense>
                                    <ListItem>
                                        <ListItemIcon>
                                            <ChevronLeftRoundedIcon />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={Translate.importHint1}
                                        />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <ChevronLeftRoundedIcon />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={Translate.importHint2}
                                        />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <ChevronLeftRoundedIcon />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={Translate.importHint3}
                                        />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <ChevronLeftRoundedIcon />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={Translate.importHint4}
                                        />
                                    </ListItem>
                                </List>
                            </Grid>*/}
                            {
                                !!errors.length &&
                                <Grid item xs={12}>
                                    <Alert severity="warning" className="excel-alert" style={{background:'rgb(244 244 244)',width:"100%"}}>
                                        <AlertTitle>{Translate.theseErrorsHappendsInimporting}:</AlertTitle>
                                        <TableContainer style={{marginBottom:5}}>
                                            <Table size="small"  style={{width:"100%",marginTop:20}}>
                                                <TableHead style={{background:"#232f3e",color:"#fff"}}>
                                                    <TableRow>
                                                        <TableCell  style={{background:"#232f3e",color:"#fff"}}>{Translate.index_number}</TableCell>
                                                        <TableCell  style={{background:"#232f3e",color:"#fff"}}>{Translate.status}</TableCell>
                                                        <TableCell  style={{background:"#232f3e",color:"#fff"}}>{Translate.status_description}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        errors.map((error,index) => (
                                                            <TableRow key={index} >
                                                                {
                                                                    error === "ok" ?
                                                                        <>
                                                                            <TableCell>{index + 2}</TableCell>
                                                                            <TableCell style={{color:"#3eaa23"}}>{Translate.approved}</TableCell>
                                                                            <TableCell style={{color:"#3eaa23"}}>{Translate.withoutError}</TableCell>
                                                                        </>
                                                                        :
                                                                        <>
                                                                            <TableCell>{index + 2}</TableCell>
                                                                            <TableCell style={{color:"#ed1d1d"}}>{Translate.not_approved}</TableCell>
                                                                            <TableCell style={{color:"#ed1d1d"}}>{error}</TableCell>
                                                                        </>
                                                                }
                                                            </TableRow>

                                                        ))
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        <span>{Translate.pleaseSolveErrorsAndRetry}</span>
                                    </Alert>
                                </Grid>

                            }
                            {
                                (!dry_run && !errors.length) &&
                                <Grid item xs={12}>
                                    <Alert severity={"success"}>
                                        {Translate.allProductsImportedDry}
                                    </Alert>
                                </Grid>
                            }
                            <Grid item xs={12} style={{textAlign:"center"}}>
                                <Typography style={{border:"1px solid #232f3e",color:"#232f3e",background:"#fff578",display:'inline',padding:"7px 10px",borderRadius:6}}>
                                    {Translate.importHint4}
                                </Typography>
                            </Grid>

                        </Grid>
                    </DialogContent>
                    <DialogActions style={{display:"flex",justifyContent:"center"}}>
                        {
                            !!dry_run ?
                                <LoadingButton
                                    variant="contained"
                                    color={!!dry_run ? "secondary" : "primary"}
                                    disabled={!file || (file.extension !== "xlsx") || !!errors.length}
                                    onClick = {this.handleSubmit.bind(this)}
                                    loading = {SubmitLoading}
                                >
                                    {!!dry_run ? Translate.sendToTest : Translate.uploadImportFile}
                                </LoadingButton>
                                :
                                <LoadingButtonWithConfirmation
                                    variant="contained"
                                    color={"primary"}
                                    disabled={!file || (file.extension !== "xlsx") || !!errors.length}
                                    onClick = {this.handleSubmit.bind(this)}
                                    loading = {SubmitLoading}
                                    icon={<CheckBoxRoundedIcon/>}
                                    cColor="#52F436"
                                >
                                    {Translate.uploadImportFile}
                                </LoadingButtonWithConfirmation>
                        }
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}
const mstp = state => ({
    user: state.user,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(ExcelImportButton)))));